// @flow
import styled from 'styled-components';

export const Background = styled.rect`fill: ${p => p.theme.white};`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/control-panel/style.js